import Decimal from "decimal.js";
import { Token } from "store/global/TokenEnum";
import { Amount } from "types/amount";
import { Text } from "components/general/Text";
import { GlobalStore } from "store/global/GlobalStore";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { SerializedStyles } from "@emotion/react";

interface AmountAndUsdPriceFullWidthProps {
  symbol: Token;
  amount: Amount;
  usdValue: Decimal;
  isAmountShown: boolean;
  dimAmountValues?: boolean;
  css?: SerializedStyles;
}

export const AmountAndUsdPriceFullWidth = ({
  symbol,
  amount,
  usdValue,
  isAmountShown,
  dimAmountValues,
  css,
}: AmountAndUsdPriceFullWidthProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const tokenList = useTokenListByChain();

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        width: "100%",
        gap: 10,
        top: -8,
        opacity: dimAmountValues ? 0.5 : 1,
      }}
    >
      {amount.value.gt(0) && usdValue.gt(0) && (
        <>
          <div style={{ width: "50%", textAlign: "end" }}>
            {isAmountShown && (
              <Text textStyle="Paragraph" size="Large" css={css} color={theme.font.primary.default}>
                {amount.toDisplay(symbol, tokenList)}
              </Text>
            )}
          </div>
          <div style={{ width: "50%" }}>
            <Text textStyle="Paragraph" size="Large" css={css} color={theme.font.secondary.default}>
              $
              {Intl.NumberFormat(navigator.language, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }).format(usdValue.toNumber())}
            </Text>
          </div>
        </>
      )}
    </div>
  );
};
